import { render, staticRenderFns } from "./VCplTooltip.vue?vue&type=template&id=54d27706"
import script from "./VCplTooltip.vue?vue&type=script&lang=js"
export * from "./VCplTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports